import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AuthStatus } from '@shared/models/auth/auth.model';
import { AuthService } from '../services/auth.service';

/**
 * Usuário já autenticado não deve ver /inicio nem /auth/login: encaminha
 * direto para o redirectUrl pendente (se houver) ou para a home.
 *
 * Exceção: pousos vindos de bounce do AuthInterceptor chegam com
 * ?sessionExpired=true — o refresh pode ter falhado por rede com tokens
 * ainda "válidos" pelo relógio local; auto-redirecionar nesse caso criaria
 * loop inicio → home → 401 → inicio. Nesses pousos a página é exibida
 * normalmente para o usuário refazer o login.
 */
export const redirectIfAuthenticated = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  const router = inject(Router);

  if (route.queryParams['sessionExpired']) return true;
  if (inject(AuthService).isAuthenticated() === AuthStatus.ALL_TOKENS_INVALID) return true;

  const redirectUrl = route.queryParams['redirectUrl'];
  if (redirectUrl) {
    try {
      return router.parseUrl(redirectUrl);
    } catch {
      // redirectUrl malformado — cai para a home
    }
  }
  return router.createUrlTree(['/home']);
};
